module.exports = "assets/4bf049ce8ef45627d9edeb1078b9c9db.glb";